import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '..';

type State = {
  private: boolean;
};

const initialState: State = {
  private: false,
};

const privateModeSlice = createSlice({
  name: 'privateMode',
  initialState,
  reducers: {
    updatePrivateMode(state: State, action: PayloadAction<boolean>) {
      state.private = action.payload;
    },
  },
});

export const { updatePrivateMode } = privateModeSlice.actions;

export const selectPrivateMode = (state: RootState) => state.privateMode.private;

export default privateModeSlice.reducer;
